import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import AdminDashboard from "src/pages/AdminDashboard/index";
import { useHistory } from "react-router-dom";
import AdminBookingSettingReservationPage from "src/pages/AdminDashboard/Businesses/NewAdminBookingSettings/Reservation";
import FiscalDepartmentSettingsPage from "src/pages/AdminDashboard/Businesses/NewAdminBookingSettings/FiscalDepartmentSettings";
import VivaAccountsSettingsPage from "src/pages/AdminDashboard/Businesses/NewAdminBookingSettings/VivaAccounts";
import TicketVendingMachineSettingsPage from "src/pages/AdminDashboard/Businesses/NewAdminBookingSettings/TicketVendingMachine";

const NewAdminBookingSettingsPage = () => {
  const history = useHistory();

  const pathParts = location.pathname.split("/");
  const selectedTab = pathParts[pathParts.length - 1];
  const availableTabs = [
    "reservations",
    "fiscal_department_settings",
    "viva_accounts",
    "ticket_vending_machine",
  ];
  const activeTab = availableTabs.includes(selectedTab)
    ? selectedTab
    : "reservations";

  const handleTabSelect = (key) => {
    history.push(`${key}`);
  };

  return (
    <AdminDashboard>
      <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
        <Tab title="Reservierungen" eventKey={"reservations"}>
          <AdminBookingSettingReservationPage />
        </Tab>
        <Tab title="Steuersätze" eventKey={"fiscal_department_settings"}>
          <FiscalDepartmentSettingsPage />
        </Tab>
        <Tab title="Viva Accounts" eventKey={"viva_accounts"}>
          <VivaAccountsSettingsPage />
        </Tab>
        <Tab title="Automat" eventKey={"ticket_vending_machine"}>
          <TicketVendingMachineSettingsPage />
        </Tab>
      </Tabs>
    </AdminDashboard>
  );
};

export default NewAdminBookingSettingsPage;
